"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../../Buttons/Button"));

var _Link = _interopRequireDefault(require("../../Buttons/Link"));

var _RowOneCol = _interopRequireDefault(require("../../LayoutContainers/RowOneCol"));

var _RowTwoCol = _interopRequireDefault(require("../../LayoutContainers/RowTwoCol"));

var _ParagraphText = _interopRequireDefault(require("../../TextElements/BasicTextElements/ParagraphText"));

var _Contact = require("./Contact.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// external
// ours
// resources

/**
 * This is the standard "contact us" component containing email, phone and hours
 */
var Contact = function Contact(_ref) {
  var businessHours = _ref.businessHours,
      dataTestId = _ref.dataTestId,
      email = _ref.email,
      phoneNo = _ref.phoneNo;
  return /*#__PURE__*/_react.default.createElement(_Contact.StyledContactWrapper, {
    "data-test-id": dataTestId
  }, /*#__PURE__*/_react.default.createElement(_RowTwoCol.default, null, /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
    childkey: "leftContent",
    dataTestId: "contact-phone-text"
  }, /*#__PURE__*/_react.default.createElement("strong", {
    className: "c-contact-desktop"
  }, "Call Us:", ' ', /*#__PURE__*/_react.default.createElement("br", null), phoneNo), /*#__PURE__*/_react.default.createElement("strong", {
    className: "c-contact-mobile"
  }, "Call Us:", ' ', /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Link.default, {
    dataTestId: "contact-mobile-link",
    className: "c-contact-mobile-link",
    href: "tel://".concat(phoneNo)
  }, phoneNo))), /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:".concat(email),
    childkey: "rightContent"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    dataTestId: "contact-email-us"
  }, "Email Us"))), /*#__PURE__*/_react.default.createElement(_RowOneCol.default, null, /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
    className: "c-contact-hours-text",
    dataTestId: "contact-hours-text"
  }, businessHours)));
};

Contact.propTypes = {
  /** business hours to display */
  businessHours: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** email to display */
  email: _propTypes.default.string,

  /** phone number to display */
  phoneNo: _propTypes.default.string
};
Contact.defaultProps = {
  phoneNo: '(833) 230-2253',
  businessHours: 'Cake\'s hours are Monday-Friday, 8am-5pm MT',
  email: 'support@cakeinsure.com'
};
var _default = Contact;
exports.default = _default;